import React, { useCallback, useMemo } from 'react'
import { CenterPanel } from 'view/routes/routesLayout'
import { CollateralBasketHeroPanel } from './CollateralBasketHeroPanel'
import { authorisedAvailableCollateralBasketDetailsSelector } from 'selectors/collateralBasketSelectors'
import { WindowActions } from 'epics/windowEpic'
import { useDispatch, useSelector } from 'react-redux'
import { GridId } from 'store/grid'
import { getCollateralBasketColumnDefs, CollateralBasketGridOptions } from './CollateralBasketGridModel'
import { DataGrid } from 'view/components/datagrid'

export const CollateralBasketScreen = () => {
  const dispatch = useDispatch()
  const collateralBasketList = useSelector(authorisedAvailableCollateralBasketDetailsSelector)
  const onTearout = useCallback(() => dispatch(WindowActions.tearoutGrid('quote/tearout/baskets')), [dispatch])
  const colDefs = useMemo(() => getCollateralBasketColumnDefs(true), [])

  return (
    <CenterPanel>
      <CollateralBasketHeroPanel collateralBasketList={collateralBasketList} onTearout={onTearout} />
      <DataGrid
        gridId={GridId.CollateralBasketGrid}
        gridOptions={CollateralBasketGridOptions}
        rowData={collateralBasketList}
        columnDefs={colDefs}
      />
    </CenterPanel>
  )
}
